import style from "./style.json"

export default {
  color(colorSTR) {
    let alphaSTR = 1
    if (colorSTR.includes("*")) {
      let color_alphaARR = colorSTR.split("*")
      colorSTR = color_alphaARR[0]
      alphaSTR = color_alphaARR[1]
    } 
    return "rgba(" + style.color[colorSTR] + ", " + style.alpha[alphaSTR] + ")"
  },
  colorMerge(colorSTR, bgcolorSTR, factor) {
    // Remove alphas
    if (colorSTR.includes("*")) {
      colorSTR = colorSTR.substring(0, colorSTR.indexOf("*"))
    }
    if (bgcolorSTR.includes("*")) {
      bgcolorSTR = bgcolorSTR.substring(0, bgcolorSTR.indexOf("*"))
    }
    // Split colors into RGB
    let colorARR = style.color[colorSTR].split(", ")
    let bgcolorARR = style.color[bgcolorSTR].split(", ")

    // Merge colors
    let r = ((+colorARR[0]) * (+factor)) + ((+bgcolorARR[0]) * (1- (+factor)))
    let g = ((+colorARR[1]) * (+factor)) + ((+bgcolorARR[1]) * (1- (+factor)))
    let b = ((+colorARR[2]) * (+factor)) + ((+bgcolorARR[2]) * (1- (+factor)))
    return "rgb(" + r + ", " + g + ", " + b + ")"
  },
  zIndex(value) {
    let plus = 0
    if (value.includes("+")) {
      let value_plusARR = value.split("+")
      value = value_plusARR[0]
      plus = value_plusARR[1]
    }
    return +this.zList[value] + +plus
  },
  zList : {
    "modal" : "1000",
    "sticky" : "200",
    "dashb" : "100",
    "base" : "0",
    "tooltip" : "1",
  },
  alignList : {
    "" : "center;",
    "stretch" : "stretch;",
    "top" : "flex-start;",
    "bottom" : "flex-end;",
    "baseline" : "baseline;",
  },
  rndList : {
    "switch" : "100px",
    "btnlogo" : "15px",
    "btnxl" : "13px",
    "btnl" : "10px",
    "btnm" : "6px",
    "btns" : "4px",
    "right": "0 15px 15px 0",
    "bottom" : "0 0 15px 15px",
  },  
  styleKey(item) {
    let value = ""
    if (item.includes("-")) {
      let splitpair = item.split('-')
      item = splitpair[0]
      value = splitpair[1]
    }
    switch(item) {
      // Colors
      case "color":
        return "color: " + this.color(value) + ";"
      case "bg":
        return "background-color: " + this.color(value) + ";"
      case "bgi":
        return "background-image: " + style.gradient[value] + ";"
      // Color & Border
      case "border":
        if (value == "none") {return "border: 0 none;"}
        else if (value == "hidden") {return "border: 1px solid; border-color: rgb(0, 0, 0, 0);"}
        else {return "border: 1px solid; border-color: " + this.color(value) + ";"}
      // Borders
      case "rnd":
        return "border-radius: " + this.rndList[value] + ";"
      case "shadow":
        return "box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.5);"
      case "bigshadow":
        return "box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.7);"
      // Other
      case "line":
        if (value == "v") {return "border-left: 1px solid; width:1px; border-color: " + this.color('bglow') + ";"}
        else if (value == "h") {return "border-top: 1px solid; height:1px; border-color: " + this.color('bglow') + ";"}
        else if (value == "selection") {return "height: 8px; background-color: " + this.color('darkselected') + ";"}
        break
      case "action":
        return "cursor: pointer; user-select: none;"
      case "row":
        return "display: flex; flex-flow: row; justify-content : flex-start;align-items:" + this.alignList[value] + ";"
      case "rowcenter":
        return "display: flex; flex-flow: row; justify-content : center;align-items:" + this.alignList[value] + ";"
      case "col":
        return "display: flex; flex-flow: column; align-items: center;justify-content : flex-start;"
      case "z":
        return "z-index: " +this.zIndex(value) + ";"
      // Padding and margin
      case "p":
        return "padding: " + value + "rem;"
      case "m":
        return "margin: " + value + "rem;"
      case "pleft":
        return "padding-left: " + value + "rem;"
      case "mleft":
        return "margin-left: " + value + "rem;"
      case "pright":
        return "padding-right: " + value + "rem;"
      case "mright":
        return "margin-right: " + value + "rem;"
      case "ptop":
        return "padding-top: " + value + "rem;"
      case "mtop":
        return "margin-top: " + value + "rem;"
      case "pbottom":
        return "padding-bottom: " + value + "rem;"
      case "mbottom":
        return "margin-bottom: " + value + "rem;"
      default:
        return ""
    } 
  },
  get(stylesSTR) {
    let target = {}
    stylesSTR.split(" ").forEach(pair => {
      let splitpair = pair.split('-');
      let key = splitpair[0];
      target[key] = splitpair[1];
    })
    return target
  },
  new(typeSTR) {
    // StyleOBJ
    let styleOBJ = {
      type : typeSTR,
      common: [],
      inactive: [],
      active: [],
      focus: [],
      hover: [],
      // Sub-Items
      items: {
        common: [],
        inactive: [],
        active: [],
        focus: [],
        hover: [],        
      },
    }
    return styleOBJ
  },
}
